import type { UnsubscribeDetailSource, UnsubscribeReason } from '../types/api';

/** The reasons as the person saw them on the unsubscribe page (edge html.ts, English copy). */
export const UNSUBSCRIBE_REASON_LABELS: Record<UnsubscribeReason, string> = {
  too_many: 'Too many mails',
  not_relevant: "The content isn't relevant to me",
  not_customer: "I'm no longer a NoPain customer",
  by_mistake: 'I signed up by mistake',
  other: 'Another reason',
};

export const UNSUBSCRIBE_DETAIL_SOURCE_LABELS: Record<UnsubscribeDetailSource, string> = {
  link_click: 'Unsubscribe link in a mail',
  header_one_click: 'Unsubscribe button in the mail app',
  preference_centre: 'Deleted from the preference centre',
  manual: 'Deleted by an admin',
};
